import React, { useEffect } from "react";
import { Alert as BSAlert } from "react-bootstrap";
import { useLocation } from "react-router-dom";

import { alertActions } from "../features/alert/alertSlice";
import { useAppDispatch, useAppSelector } from "../hooks/reduxHooks";

const Alert = (): React.ReactNode => {
    const { dismissible, level, settings, show, text, title, persist } =
        useAppSelector(state => state.alert);
    const dispatch = useAppDispatch();
    const location = useLocation();

    useEffect(() => {
        !persist && dispatch(alertActions.clear());
    }, [location]);

    if (!show) return null;

    return (
        <BSAlert
            variant={level}
            className={`col-4 col-offset-4 mx-auto mt-4 mb-2 text-center ${
                settings ? settings : ""
            }`}
            show={show}
            onClose={() => dispatch(alertActions.clear())}
            dismissible={persist ? true : dismissible || false}
        >
            {title && <BSAlert.Heading as="h5">{title}</BSAlert.Heading>}
            <p className="p-0 m-0">{text}</p>
        </BSAlert>
    );
};

export default Alert;
